module.exports = __webpack_public_path__ + "static/media/HappyFace.07258bc7.png";